var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { rawTimeZones } from '@vvo/tzdb';
import React from 'react';
import { convertOffsetInMinutesToString } from './Util';
function getTimeZones() {
    // Sort timezones according to time offset.
    var timeZones = rawTimeZones.sort(function (tzA, tzB) {
        var offsetDiff = tzA.rawOffsetInMinutes - tzB.rawOffsetInMinutes;
        if (offsetDiff === 0) {
            if (tzA.countryName === tzB.countryName) {
                if (tzA.mainCities[0] < tzB.mainCities[0]) {
                    return -1;
                }
                else {
                    return 1;
                }
            }
            else if (tzA.countryName < tzB.countryName) {
                return -1;
            }
            else {
                return 1;
            }
        }
        else {
            return offsetDiff;
        }
    });
    return timeZones;
}
var TimeZoneSelect = function (props) {
    var timeZones = React.useMemo(getTimeZones, []);
    var handleChange = function (event) {
        props.onChange(event.target.value);
    };
    return (_jsx(Select, __assign({ value: props.timeZoneName, onChange: handleChange }, { children: timeZones.map(function (timeZone) {
            var title = timeZone.countryName + ' / ' + timeZone.mainCities[0];
            return (_jsx(MenuItem, __assign({ value: timeZone.name }, { children: convertOffsetInMinutesToString(timeZone.rawOffsetInMinutes) +
                    ' : ' +
                    title }), timeZone.name));
        }) })));
};
export default TimeZoneSelect;
//# sourceMappingURL=TimeZoneSelect.js.map